const MEMBERSHIP_LOGIN_PATH = '/_hcms/mem/login?redirect_url=';
const MEMBERSHIP_LOGOUT_PATH = '/_hcms/mem/logout?redirect_url=';
export const getMembershipLoginUrl = redirectUrl => {
  return `${MEMBERSHIP_LOGIN_PATH}${encodeURIComponent(redirectUrl)}`;
};
export const getMembershipLogoutUrl = portalRootUrl => {
  return `${MEMBERSHIP_LOGOUT_PATH}${encodeURIComponent(`${MEMBERSHIP_LOGIN_PATH}${encodeURIComponent(portalRootUrl)}`)}`;
};